// RoleGuard — оборачивает страницы/секции, которые доступны только определённым ролям.
//   <RoleGuard roles={['creator']}><TenantsPage /></RoleGuard>
//
// Если роль не подходит — рендерим явный 403, а не молча редиректим:
// пользователь должен понимать, почему страница недоступна (особенно если
// пришёл по прямой ссылке).

import { Alert, Container, Title, Text, Stack } from '@mantine/core';
import { useAuth } from './AuthContext.jsx';

export function RoleGuard({ roles, children }) {
    const { user } = useAuth();
    if (!user) return null;
    if (roles.includes(user.role)) return children;

    return (
        <Container size="sm" py="xl">
            <Stack gap="md">
                <Title order={2}>Нет доступа</Title>
                <Alert color="red" variant="light">
                    <Text>
                        Эта страница доступна только для роли:{' '}
                        <strong>{roles.join(', ')}</strong>.
                    </Text>
                    <Text size="sm" c="dimmed" mt="xs">
                        Ваша роль — <strong>{user.role}</strong>.
                    </Text>
                </Alert>
            </Stack>
        </Container>
    );
}
